import React from 'react';
import moment from 'moment-timezone';
import { useIntl } from 'react-intl';
import Translate from '@spordle/intl-elements';

import { formatFullDate } from '../../lib';
import { useLocale } from '../../i18n';
import { useParticipant } from '../../queries/participants';

const getProfileLink = participantId => `/players/${participantId}`;

export const getBirthdate = (birthdate, locale) => {
  if (!birthdate) return;
  return `${formatFullDate(birthdate, locale, 'UTC')} (${moment.utc().diff(birthdate, 'years')})`
}

export const getMeta = ({ height, weight }) => {
  return [ height, weight ].filter(Boolean).join(' / ');
}

const ProfileAttribute = ({ name, value }) => {
  return <>
    <dt className="col-sm-4">{name}</dt>
    <dd className="col-sm-8">{value || '--'}</dd>
  </>
}

export const ProfilePicture = ({ picture, width = 100, height = 100 }) => {
  if (!picture) return <img className="profile-picture-placeholder mb-2 shadow-sm" src="participant-placeholder.png" />
  return <img className="rounded-circle mb-2 shadow-sm" src={picture.url} width={width} height={height} />;
}

export default ({ profile, stats }) => {
  const [ locale ] = useLocale()
  const { formatMessage } = useIntl();
  const { participant } = useParticipant(profile?.id);

  if (!profile || !participant) return null;
  const { id: participantId, picture: profilePicture, birthdate, hometown, dexterity } = profile;
  const isPlayer = stats && stats.positions && !stats.positions.includes('G')

  const picture = participant?.pictureUrl ? { url: participant?.pictureUrl } : profilePicture

  return <div className="row no-gutters">
    <div className="col-sm-6 d-flex flex-column align-items-center">
      <ProfilePicture picture={picture} />
      <div>{getMeta(profile)}</div>
    </div>
    <div className="col-sm-6">
      <dl className="row no-gutters">
        <ProfileAttribute name={<Translate id="components.profile.birthdate" />} value={getBirthdate(birthdate, locale)} />
        <ProfileAttribute name={<Translate id="components.profile.hometown" />} value={hometown} />
        <ProfileAttribute
          name={isPlayer ? <Translate id="components.profile.shoots" /> : <Translate id="components.profile.catches" />}
          value={dexterity ? formatMessage({ id: `common.lang.${dexterity.toLowerCase()}` }) : null}
        />
        {participantId && <a href={getProfileLink(participantId)}>{formatMessage({ id: 'components.profile.view.full' })}</a>}
      </dl>
    </div>
  </div>
}
